<template>
  <v-container fluid :id="pageName + '-container'" class="px-0 py-0">
    <div :id="pageName" class="banner-page">
      <slot></slot>
    </div>
  </v-container>
</template>

<script>

export default {
  name: 'BannerPage',

  props: {
    pageName: {
      type: String,
      required: true
    },

    image: {
      type: String,
      required: true
    }
  },

  data: () => ({
    timeout: null
  }),

  methods: {
    setBackgroundImage () {
      const rootEl = document.querySelector(`#${this.pageName}`)

      if (rootEl) {
        rootEl.style.backgroundImage = `linear-gradient(to bottom, rgb(0, 57, 64, 0.95), rgb(53, 113, 51, 0.5), rgb(53, 113, 51, 0.75), rgb(0, 57, 64, 0.75)), url(${this.image})`
      } else {
        this.timeout = setTimeout(this.setBackgroundImage, 100)
      }
    }
  },

  mounted () {
    this.timeout = setTimeout(this.setBackgroundImage, 100)
  }
}
</script>

<style scoped>
.banner-page {
  width: 100vw;
  height: 100vh;
  padding-left: 0px;
  padding-right: 0px;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0, auto;
}
</style>
